module.exports = __webpack_public_path__ + "img/bed-blue.59a2f2d8.jpg";